/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicTicketEvent } from './PublicTicketEvent';
import {
    PublicTicketEventFromJSON,
    PublicTicketEventFromJSONTyped,
    PublicTicketEventToJSON,
    PublicTicketEventToJSONTyped,
} from './PublicTicketEvent';

/**
 * 
 * @export
 * @interface ResultOfPublicTicketEvent
 */
export interface ResultOfPublicTicketEvent {
    /**
     * 
     * @type {PublicTicketEvent}
     * @memberof ResultOfPublicTicketEvent
     */
    data: PublicTicketEvent | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfPublicTicketEvent
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfPublicTicketEvent
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfPublicTicketEvent interface.
 */
export function instanceOfResultOfPublicTicketEvent(value: object): value is ResultOfPublicTicketEvent {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfPublicTicketEventFromJSON(json: any): ResultOfPublicTicketEvent {
    return ResultOfPublicTicketEventFromJSONTyped(json, false);
}

export function ResultOfPublicTicketEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfPublicTicketEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PublicTicketEventFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfPublicTicketEventToJSON(json: any): ResultOfPublicTicketEvent {
    return ResultOfPublicTicketEventToJSONTyped(json, false);
}

export function ResultOfPublicTicketEventToJSONTyped(value?: ResultOfPublicTicketEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PublicTicketEventToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

